import { Typography } from '@mui/material';
import React from 'react';
import ScheduledMessages from '../../components/Messages/ScheduledReplies/ScheduledMessages';

const ScheduledMessagesPage = () => {
    return (
        <>
            <Typography variant='h1'>Scheduled Messages</Typography>
            <ScheduledMessages />
        </>
    );
};

export default ScheduledMessagesPage;
